{
  "GENERAL": [],
  "SOCIAL": ["FACEBOOK", "TWITTER", "LINKEDIN", "INSTAGRAM", "MYSPACE"],
  "MESSAGING": ["SKYPE"]
}
